// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Cobra_launcher from "@literacyplanet/cobra_launcher";
import * as CobraGenericBehaviourContext$LiteracyplanetClientFlags from "./CobraGenericBehaviourContext.res.mjs";

var merge = (function (a, b) {
    if (a.contents) {
      a.contents = {
        ...a.contents,
        ...b
      }
      return a;
    }

    return {
      ...a,
      ...b
    }
  });

function CobraContainer(props) {
  var d = props.onDispatch;
  var p = props.props;
  var view = props.view;
  var match = CobraGenericBehaviourContext$LiteracyplanetClientFlags.use();
  var onDispatch = match.onDispatch;
  var props$1 = match.props;
  return React.useMemo((function () {
                return React.createElement(Cobra_launcher.CobraLauncher, {
                            width: "1280",
                            height: "768",
                            view: view,
                            name: view,
                            props: merge(p, props$1),
                            onDispatch: merge(d, onDispatch)
                          });
              }), [
              p,
              props$1,
              view
            ]);
}

var make = CobraContainer;

export {
  merge ,
  make ,
}
/* react Not a pure module */
